export default __webpack_public_path__ + "static/why-choose-4c126aa888434e34c95734061a818b00.webp";